import { render, staticRenderFns } from "./Indicadores.vue?vue&type=template&id=bb1c70a4&scoped=true"
import script from "./Indicadores.vue?vue&type=script&lang=js"
export * from "./Indicadores.vue?vue&type=script&lang=js"
import style0 from "./Indicadores.vue?vue&type=style&index=0&id=bb1c70a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1c70a4",
  null
  
)

export default component.exports